"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandedRepetitionsVisitor = void 0;
const ExpandedContextVisitor_1 = require("../expandedContext/ExpandedContextVisitor");
const structure_1 = require("../structure");
class ExpandedRepetitionsVisitor extends ExpandedContextVisitor_1.ExpandedContextVisitor {
    answersResolver;
    constructor(answersResolver) {
        super(ExpandedContextVisitor_1.RepetitionIntervalBoundary.minRepetitions);
        this.answersResolver = answersResolver;
    }
    numberOfRepetitions(repeatableNode) {
        const { options } = repeatableNode;
        if ((0, structure_1.isRepeatableOptionsBasedOnCollection)(options)) {
            return (this.answersResolver
                .usingNodeId()
                .getRepetitionCount(options.expandToCollectionLength, this.repeatedInstanceIdentifiers().byNodeId) ?? 0);
        }
        const boundaryNumberOfRepetitions = super.numberOfRepetitions(repeatableNode);
        const existingNumberOfRepetitions = this.existingNumberOfRepetitions(repeatableNode);
        return Math.max(boundaryNumberOfRepetitions, existingNumberOfRepetitions);
    }
    existingNumberOfRepetitions(repeatableNode) {
        return (this.answersResolver
            .usingNodeId()
            .getRepetitionCount(repeatableNode.nodeId, this.repeatedInstanceIdentifiers().byNodeId) ?? 0);
    }
}
exports.ExpandedRepetitionsVisitor = ExpandedRepetitionsVisitor;
